/* unplugin-vue-components disabled */import { render } from "./burger.vue?vue&type=template&id=9ae70fb6"
const script = {}

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/burger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ae70fb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ae70fb6', __exports__)) {
    api.reload('9ae70fb6', __exports__)
  }
  
  module.hot.accept("./burger.vue?vue&type=template&id=9ae70fb6", () => {
    api.rerender('9ae70fb6', render)
  })

}


export default __exports__